export const postAttachments = (state) => state.attachments;
